import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import PrimaryButton from 'components/layout/buttons/PrimaryButton';
import translations from 'services/translations/translations';
import { addMessage } from 'store/messages/actions';
import { setWallMetaData as addWallToWallsMetaData } from 'store/wallsMetaData/actions';

import { configurationChanged } from 'store/configurationChange/actions';
import wallFieldsFilled from '../services/wallFieldsFilled';
import WallProperties from '../src/wallProperties/WallProperties';
import getDefaultWall from '../services/getDefaultWall';
import getDefaultWallMetaData from '../services/getDefaultWallMetaData';
import glassWallNameFilled from '../services/glassWallNameFilled';

const AddWall = ({
  restartFields,
  selectedDot,
}: {
  restartFields: () => void;
  selectedDot: any;
}): JSX.Element | null => {
  const dispatch = useDispatch();
  const [wall, setWall] = useState(getDefaultWall());
  const [wallMetaData, setWallMetaData] = useState(getDefaultWallMetaData());

  const { t } = useTranslation([translations.common]);

  const restartName = () => {
    setWallMetaData({
      ...wallMetaData,
      name: '',
    });
  };

  const addWall = () => {
    if (!selectedDot) {
      dispatch(
        addMessage(t(`${translations.common}:Modal Messages.Starting Point`))
      );

      return;
    }

    if (!wallFieldsFilled(wall) || !glassWallNameFilled(wallMetaData, wall)) {
      dispatch(
        addMessage(t(`${translations.common}:Modal Messages.Fill All Fields`))
      );

      return;
    }

    dispatch(configurationChanged());

    const twoDObjectsBeforeAdd = [...window.all2dObjects];
    window.AddWallLineAndConnection(wall);
    const twoDObjectsAfterAdd = [...window.all2dObjects];

    const created = twoDObjectsAfterAdd
      .filter((object) => !twoDObjectsBeforeAdd.includes(object))
      .map((object) => object.split(' '))
      .filter((parts) => parts[0] === 'WallLine');

    if (created.length > 0) {
      dispatch(
        addWallToWallsMetaData({
          ...wallMetaData,
          identifier: created[0][1],
        })
      );
    }
    restartName();
    restartFields();
  };

  return (
    <>
      <div className="instructions-text">
        <p>{t(`${translations.common}:Modal Messages.Starting Point`)}</p>
      </div>
      <WallProperties
        action="add"
        setWall={(w) => setWall({ ...w, wallName: wallMetaData.name })}
        setWallMetaData={(m) => {
          setWall({ ...wall, wallName: m.name });
          setWallMetaData(m);
        }}
        wall={wall}
        wallMetaData={wallMetaData}
      />
      <PrimaryButton onClick={addWall}>
        {t(`${translations.common}:Add`).toLocaleUpperCase()}
      </PrimaryButton>
    </>
  );
};

export default AddWall;
